<template>
  <div v-if="loading" class="over container">
    <div class="row" style="height: 45vh">
      <div class="col-12"></div>
    </div>
    <div class="row">
      <div class="spinner-border text-primary center" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
  </div>
  <div v-else class="container mt-0 background" style="direction: ltr;">
    <!-- *************************SHOW SPECIFIC INFO PAGE********************************* -->

    <div class="over fadeIn" id="specificInfoPage">
      <div class="row">

          <div class="col-3 text-center pt-2" @click="openPrevious">
            <div class="captionArrow">Back</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30px"
              height="30px"
              fill="currentColor"
              class="bi bi-arrow-left"
              viewBox="0 0 16 16"
              style="bottom: 5px; position: relative"
            >
              <path
                fill-rule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
              />
            </svg>

          </div>

          <div
            class="text-center col-6 pe-0"
          >
          </div>
          <div
            class="col-3 text-center pt-2"
            @click="openNext"
          >
            <div class="captionArrow">Next</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30px"
              height="30px"
              fill="currentColor"
              class="bi bi-arrow-right"
              viewBox="0 0 16 16"
              style="bottom: 5px; position: relative"
            >
              <path
                fill-rule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
              />
            </svg>
         
          </div>


        <div
          class="col-12 justify-content-bottom align-self-end"
          style="
            color: grey;
            text-align: left;
            padding: 25px 35px;
            overflow: auto;
            padding: 20px 42px;
          "
        >
          <div class="title">
            A la Guerre comme à la Guerre (All’s Fair in War)
          </div>

          <div class="mt-2 subTitle">
            1. Arrow heads
          </div>
          <div class="mt-2">
            Bronze, Megiddo and Horvat Rosh Zayit, Iron Age II
          </div>

          <div class="mt-2 subTitle">
            2. Axe
          </div>
          <div class="mt-2">
            Bronze, Afula, Iron Age I
              </div>

          <div class="mt-2 subTitle">
            3. “Duck-bill”-type axe head
              </div>
          <div class=" mt-2">
            Bronze, Tel Rehov, Middle Bronze Age
          </div>

          <div class="mt-2 subTitle">
            4. Sickle-shaped sword (copy) 
             </div>
          <div class=" mt-2">
            Bronze, Afek, Late Bronze Age 
          </div>

          <div class="mt-2 subTitle">
            5. Mace heads (one with reconstructed handle)
                </div>
          <div class=" mt-2">
            Limestone and hematite, Tel Kishyon, Tel Kiri, and Horvat Rosh Zayit, Early Bronze Age and Iron Age II
          </div>

          <div class="mt-2 subTitle">
            6. Dagger
          </div>
          <div class=" mt-2">
            Bronze, Megiddo, Late Bronze Age
                  </div>

          <div class="mt-2 subTitle">
            7. Sword
                  </div>
          <div class=" mt-2">
           Bronze, Afula, Late Bronze Age
          </div>

          <div class="mt-2 subTitle">
            8. Spear head
          </div>
          <div class=" mt-2">
            Bronze, Neve Ur, Middle Bronze Age          
          </div>

          <div class="mt-2 subTitle">
            9. Arrow heads
          </div>
          <div class=" mt-2">
            Bronze, Tel Zarik, Late Bronze Age
           </div>

           <div class="mt-2 subTitle">
            10. Bent spear head
          </div>
          <div class=" mt-2">
            Bronze, Tel Kishyon, Middle Bronze Age
           </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Map from "./map";
export default {
  props: ["specificItemDetails"],

  // components: {
  //   Map,
  // },
  data() {
    return {
      showMainPage: true,
      style: "",
      showSpecificInfo: false,
      infoToShow: "",
      imageToShow: "",
      periodToShow: "",
      placeToShow: "",
      nameToShow: "",
      materialToShow: "",
      showMoreInfoOfItem: false,
      keyToReRenderAudio: 0,
      showMoreInformation: false,
      index: 0,
    };
  },
  mounted() {

  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    error() {
      return this.$store.getters.error;
    },
 
  },
  methods: {
    openNext() {
      this.$router.push({
        name: "egyptianNeighbors",
      });
    },
    openPrevious() {
      this.$router.push({
        name: "internationalRelations",
      });
    },

    onDismissed() {
      this.$store.dispatch("clearError");
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 22px;
  color: rgb(37, 37, 37);
  font-weight: bold;
}
.subTitle {
  font-size: 18px;
  color: rgb(37, 37, 37);
}
.captionArrow {
  position: absolute;
    font-size: 12px;
    top: 31px;
    left: 39px;
}
.audioButton {
  width: 100%;
  border: 2px #79a541 solid;
  border-radius: 25px;
  height: 40px;
  margin-bottom: 16px;
  position: relative;
}

.slideLeft {
  -webkit-animation: slideLeft 0.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: slideLeft 0.5s; /* Firefox < 16 */
  -ms-animation: slideLeft 0.5s; /* Internet Explorer */
  -o-animation: slideLeft 0.5s; /* Opera < 12.1 */
  animation: slideLeft 0.5s;
}
.slideRight {
  -webkit-animation: slideRight 0.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: slideRight 0.5s; /* Firefox < 16 */
  -ms-animation: slideRight 0.5s; /* Internet Explorer */
  -o-animation: slideRight 0.5s; /* Opera < 12.1 */
  animation: slideRight 0.5s;
}
.navBarTitle {
  position: relative;
  font-size: 22px !important;
  color: black;
  text-align: left;
  width: 100%;
  padding: 10px 18px;
}
.appBackground {
  background: url(../../static/img/appBackground.png) center center;
}
.titleSpan {
  z-index: 30;
  opacity: 1;
  padding: 10px;
  border: solid 1px white;
  width: 180px;
}
.backgroundImage {
  position: relative;
  text-align: center;
  color: white;
  font-size: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.backgroundImage::before {
  content: "";
  position: absolute;
  background-color: black;
  background-blend-mode: screen;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  opacity: 0.5;
}
.closingCross {
  position: absolute;
  top: -45px;
  right: 16px;
  z-index: 20;
  color: black;
  font-size: 24px;
}
.detectiveName {
  position: relative;
  bottom: 189px;
  width: 100%;
  text-align: center;
  margin: 0 auto;
  display: block;
}
.licenceImage {
  width: 100%;
}
.fadeIn {
  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1s; /* Firefox < 16 */
  -ms-animation: fadein 1s; /* Internet Explorer */
  -o-animation: fadein 1s; /* Opera < 12.1 */
  animation: fadein 1s;
}
.fadeOut {
  -webkit-animation: fadeOut 1s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadeOut 1s; /* Firefox < 16 */
  -ms-animation: fadeOut 1s; /* Internet Explorer */
  -o-animation: fadeOut 1s; /* Opera < 12.1 */
  animation: fadeOut 1s;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/* Firefox < 16 */
@-moz-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/* Internet Explorer */
@-ms-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/* Opera < 12.1 */
@-o-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideRight {
  from {
    left: 0;
  }
  to {
    left: 100vw;
  }
}
/* Firefox < 16 */
@-moz-keyframes slideRight {
  from {
    left: 0;
  }
  to {
    left: 100vw;
  }
}
/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes slideRight {
  from {
    left: 1;
  }
  to {
    left: 100vw;
  }
}
/* Internet Explorer */
@-ms-keyframes slideRight {
  from {
    left: 0;
  }
  to {
    left: 100vw;
  }
}
/* Opera < 12.1 */
@-o-keyframes slideRight {
  from {
    left: 0;
  }
  to {
    left: 100vw;
  }
}

@keyframes slideLeft {
  from {
    left: 0;
  }
  to {
    left: -100vw;
  }
}
/* Firefox < 16 */
@-moz-keyframes slideLeft {
  from {
    left: 0;
  }
  to {
    left: -100vw;
  }
}
/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes slideLeft {
  from {
    left: 0;
  }
  to {
    left: -100vw;
  }
}
/* Internet Explorer */
@-ms-keyframes slideLeft {
  from {
    left: 0;
  }
  to {
    left: -100vw;
  }
}
/* Opera < 12.1 */
@-o-keyframes slideLeft {
  from {
    left: 0;
  }
  to {
    left: -100vw;
  }
}
.imageInput {
  width: 100%;
}
.inputOnImage {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 5px;
  left: 5px;
  text-align: center;
}
.topSecret {
  position: absolute;
  bottom: -30px;
  left: -37px;
  width: 248px;
}
.roundButton {
  height: 48px !important;
  width: 128px;
  border: black solid 1px;
  color: black;
  border-radius: 5px;
  background: white;
  font-size: 18px;
}
.inputSecretCode {
  width: 40px;
}
.stopButton {
  border-radius: 10px;
  background-color: rgb(183 26 5);
  margin-top: 30px;
  font-size: 24px;
  height: 50px;
  width: 50px;
  border: solid 2px white;
}
.recButton {
  border-radius: 50px;
  background-color: rgb(183 26 5);
  margin-top: 30px;
  font-size: 24px;
  height: 50px;
  width: 50px;
  border: solid 15px white;
  animation: blinker 1s linear infinite;
}
@keyframes blinker {
  50% {
    border: solid 10px white;
  }
}
.green {
  border: solid 5px #05e01c !important;
}
.image {
  width: 100%;
}
#timer {
  height: 62px;
  background: brown;
  padding-top: 11px;
  color: white;
  margin: 0;
}
.background {
  background-color: white;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
.myModal {
  width: 320px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  background-color: white;
}
.over {
  position: absolute;
  top: 50px;
  font-size: 18px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: block;
  margin: 0px auto;
  background: white;
}
.center {
  display: block;
  margin: 0px auto;
}
.colorBtn {
  border-radius: 36px;
  min-height: 56px;
  color: white;
}
.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
}
.container {
  margin-top: 16px;
  font-size: 20px;
  min-height: 100vh;
}
</style>
